import {ResourceType} from '../../../models/mongoose/PermissionModel/enum/ResourceType'
import {PermissionType} from '../../../models/mongoose/PermissionModel/enum/PermissionType'
import {IPermissionResourceSchema} from '../../../models/mongoose/PermissionModel/types/IPermissionResourceSchema'
import {IPermissionResourceSchemaCategory} from '../../../models/mongoose/PermissionModel/types/IPermissionResourceSchemaCategory'
import {PermissionInputType} from '../../../models/mongoose/PermissionModel/enum/PermissionInputType'
import {PermissionEntityType} from '../../../models/mongoose/PermissionModel/enum/PermissionEntityType'
import {PLAN_CAP_PERMISSION_TYPES} from '../../../models/mongoose/PermissionModel/planCapPermissionTypes'

export const PermissionResourceSchemaMap = new Map<ResourceType, IPermissionResourceSchema>([
  [ResourceType.Workspace, {
    disableVisibilityPermission: true,
    accessPermissionType: PermissionType.readWorkspace,
    deletePermissionType: PermissionType.deleteWorkspace,
    updatePermissionType: PermissionType.updateWorkspace,
    createPermissionType: null,
    categories: [
      {
        title: 'general.workspace',
        items: [
          {
            permissionType: PermissionType.workspaceAdmin,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.workspaceAdministrator',
            description: 'permissionsScreen.workspaceAdministratorDescription',
          },
          {
            permissionType: PermissionType.readWorkspace,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.App]: PermissionInputType.Boolean,
              [PermissionEntityType.Agent]: PermissionInputType.Boolean,
            },
            title: 'permissionsScreen.readWorkspace',
            description: 'permissionsScreen.defaultAccessPermission',
            private: true,
            isVisible: false,
          },
          {
            permissionType: PermissionType.updateWorkspace,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.updateWorkspace',
            description: 'permissionsScreen.defaultAccessPermission',
            private: true,
          },
          {
            permissionType: PermissionType.deleteWorkspace,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.deleteWorkspace',
            description: 'permissionsScreen.defaultAccessPermission',
            private: true,
          },
          {
            permissionType: PermissionType.updatePermission,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.updatePermission',
            description: 'permissionsScreen.updatePermissionDescription',
          },
        ],
      },
      {
        title: 'permissionsScreen.billing',
        items: [
          {
            permissionType: PermissionType.manageWorkspacePaymentMethods,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.manageWorkspacePaymentMethods',
            description: 'permissionsScreen.manageWorkspacePaymentMethodsDescription',
          },
        ],
      },
      {
        title: 'permissionsScreen.invitations',
        items: [
          {
            permissionType: PermissionType.userInvitationAdmin, 
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.userInvitationAdmin',
            description: 'permissionsScreen.overwriteAllOtherPermissions',
          },
          {
            permissionType: PermissionType.readUserInvitation,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.readUserInvitation',
            description: 'permissionsScreen.readUserInvitationDescription',
          },
          {
            permissionType: PermissionType.createUserInvitation,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.createUserInvitation',
            description: 'permissionsScreen.createUserInvitationDescription',
          },
          {
            permissionType: PermissionType.updateUserInvitation,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.updateUserInvitation',
            description: 'permissionsScreen.updateUserInvitationDescription',
          },
          {
            permissionType: PermissionType.deleteUserInvitation,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.deleteUserInvitation',
            description: 'permissionsScreen.deleteUserInvitationDescription',
          },
        ],
      },
      {
        title: 'permissionsScreen.userGroups',
        items: [
          {
            permissionType: PermissionType.userGroupAdmin, 
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.userGroupAdmin',
            description: 'permissionsScreen.overwriteAllOtherPermissions',
          },
          {
            permissionType: PermissionType.createUserGroup,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.createUserGroup',
            description: 'permissionsScreen.createUserGroupDescription',
          },
          {
            permissionType: PermissionType.updateUserGroup,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.updateUserGroup',
            description: 'permissionsScreen.updateUserGroupDescription',
          },
          {
            permissionType: PermissionType.deleteUserGroup,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.deleteUserGroup',
            description: 'permissionsScreen.deleteUserGroupDescription',
          },
          {
            permissionType: PermissionType.createGroupMember,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.createGroupMember',
            description: 'permissionsScreen.createGroupMemberDescription',
          },
          {
            permissionType: PermissionType.deleteGroupMember,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.deleteGroupMember',
            description: 'permissionsScreen.deleteGroupMemberDescription',
          },
        ],
      },
      {
        title: 'permissionsScreen.skills',
        items: [
          {
            permissionType: PermissionType.skillAdmin,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.skillAdmin',
            description: 'permissionsScreen.skillAdminDescription',
          },
          {
            permissionType: PermissionType.readSkill,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.viewSkill',
            description: 'permissionsScreen.viewSkillDescription',
          },
          {
            permissionType: PermissionType.createSkill,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.createSkills',
            description: 'permissionsScreen.createSkillsDescription',
          },
          {
            permissionType: PermissionType.publishSkill,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.publishSkills',
            description: 'permissionsScreen.publishSkillsDescription',
          },
        ],
      },
      {
        title: 'permissionsScreen.agents',
        items: [
          {
            permissionType: PermissionType.agentAdmin,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.agentAdmin',
            description: 'permissionsScreen.overwriteAllOtherPermissions',
          },
          {
            permissionType: PermissionType.readAgent,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.viewAgents',
            description: 'permissionsScreen.viewAgentsDescription',
          },
          {
            permissionType: PermissionType.createAgent,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.createAgents',
            description: 'permissionsScreen.createAgentsDescription',
          },
          {
            permissionType: PermissionType.updateAgent,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.updateAgents',
            description: 'permissionsScreen.updateAgentsDescription',
          },
          {
            permissionType: PermissionType.deleteAgent,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.deleteAgents',
            description: 'permissionsScreen.deleteAgentsDescription',
          },
          {
            permissionType: PermissionType.publishAgent,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.publishAgents',
            description: 'permissionsScreen.publishAgentsDescription',
          },
          {
            permissionType: PermissionType.mentionInAgent,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.mentionAgents',
            description: 'permissionsScreen.mentionAgentsDescription',
          },
        ],
      },
      {
        title: 'permissionsScreen.whiteboards',
        items: [
          {
            permissionType: PermissionType.whiteboardAdmin,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.whiteboardAdmin',
            description: 'permissionsScreen.overwriteAllOtherPermissions',
          },
          {
            permissionType: PermissionType.readWhiteboard,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.viewWhiteboards',
            description: 'permissionsScreen.viewWhiteboardsDescription',
          },
          {
            permissionType: PermissionType.createWhiteboard,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.createWhiteboards',
            description: 'permissionsScreen.createWhiteboardsDescription',
          },
          {
            permissionType: PermissionType.updateWhiteboard,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.updateWhiteboards',
            description: 'permissionsScreen.updateWhiteboardsDescription',
          },
          {
            permissionType: PermissionType.deleteWhiteboard,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.deleteWhiteboards',
            description: 'permissionsScreen.deleteWhiteboardsDescription',
          },
          {
            permissionType: PermissionType.exportWhiteboard,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.exportWhiteboards',
            description: 'permissionsScreen.exportWhiteboardsDescription',
          },
        ],
      },
      {
        title: 'permissionsScreen.documents',
        items: [
          {
            permissionType: PermissionType.documentAdmin,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.documentAdmin',
            description: 'permissionsScreen.overwriteAllOtherPermissions',
          },
          {
            permissionType: PermissionType.readDocument,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.viewDocuments',
            description: 'permissionsScreen.viewDocumentsDescription',
          },
          {
            permissionType: PermissionType.createDocument,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.createDocuments',
            description: 'permissionsScreen.createDocumentsDescription',
          },
          {
            permissionType: PermissionType.updateDocument,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.updateDocuments',
            description: 'permissionsScreen.updateDocumentsDescription',
          },
          {
            permissionType: PermissionType.deleteDocument,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.deleteDocuments',
            description: 'permissionsScreen.deleteDocumentsDescription',
          },
          {
            permissionType: PermissionType.exportDocument,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.exportDocuments',
            description: 'permissionsScreen.exportDocumentsDescription',
          },
          {
            permissionType: PermissionType.commentDocument,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.commentDocuments',
            description: 'permissionsScreen.commentDocumentsDescription',
          },
          {
            permissionType: PermissionType.mentionInDocument,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.mentionInDocuments',
            description: 'permissionsScreen.mentionInDocumentsDescription',
          },
        ],
      },
      {
        title: 'permissionsScreen.databases',
        items: [
          {
            permissionType: PermissionType.databaseAdmin,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.databaseAdmin',
            description: 'permissionsScreen.overwriteAllOtherPermissions',
          },
          {
            permissionType: PermissionType.readDatabase,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.readAllDatabases',
            description: 'permissionsScreen.readAllDatabasesDescription',
          },
          {
            permissionType: PermissionType.createDatabase,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.createDatabases',
            description: 'permissionsScreen.createDatabasesDescription',
          },
          {
            permissionType: PermissionType.updateDatabase,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.updateDatabases',
            description: 'permissionsScreen.updateDatabasesDescription',
          },
          {
            permissionType: PermissionType.deleteDatabase,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.deleteAnyDatabase',
            description: 'permissionsScreen.deleteAnyDatabaseDescription',
          },
          {
            title: 'permissionsScreen.exportDatabases',
            description: 'permissionsScreen.exportDatabasesDescription',
            permissionType: PermissionType.exportDatabase,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
          },
        ],
      },
      {
        title: 'permissionsScreen.viewsGroup',
        items: [
          {
            permissionType: PermissionType.databaseViewAdmin,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.databaseViewAdmin',
            description: 'permissionsScreen.resourceGroupAdminDescription',
          },
          {
            permissionType: PermissionType.readDatabaseView,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.readDatabaseView',
            description: 'permissionsScreen.readDatabaseViewDescription',
          },
          {
            permissionType: PermissionType.createDatabaseView,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.createDatabaseView',
            description: 'permissionsScreen.createDatabaseViewDescription',
          },
          {
            permissionType: PermissionType.updateDatabaseView,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.updateDatabaseView',
            description: 'permissionsScreen.updateDatabaseViewDescription',
          },
          {
            permissionType: PermissionType.deleteDatabaseView,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.deleteDatabaseView',
            description: 'permissionsScreen.deleteDatabaseViewDescription',
          },
        ],
      },
      {
        title: 'permissionsScreen.properties',
        items: [
          {
            permissionType: PermissionType.databasePropertyAdmin,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.databasePropertyAdmin',
            description: 'permissionsScreen.resourceGroupAdminDescription',
          },
          {
            permissionType: PermissionType.readDatabaseProperty,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.readDatabaseProperties',
            description: 'permissionsScreen.readDatabasePropertiesDescription',
          },
          {
            permissionType: PermissionType.createDatabaseProperty,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.createDatabaseProperties',
            description: 'permissionsScreen.createDatabasePropertiesDescription',
          },
          {
            permissionType: PermissionType.updateDatabaseProperty,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.updateDatabaseProperties',
            description: 'permissionsScreen.updateDatabasePropertiesDescription',
          },
          {
            permissionType: PermissionType.updateItemValue,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.updateDatabaseItemValues',
            description: 'permissionsScreen.updateDatabaseItemValuesDescription',
          },
          {
            permissionType: PermissionType.deleteDatabaseProperty,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.deleteDatabaseProperties',
            description: 'permissionsScreen.deleteDatabasePropertiesDescription',
          },
          {
            permissionType: PermissionType.moveDatabaseProperties,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.moveDatabaseProperties',
            description: 'permissionsScreen.moveDatabasePropertiesDescription',
          },
        ],
      },
      {
        title: 'permissionsScreen.items',
        items: [
          {
            permissionType: PermissionType.itemAdmin,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.itemAdmin',
            description: 'permissionsScreen.resourceGroupAdminDescription',
          },
          {
            permissionType: PermissionType.readItem,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.readDatabaseItems',
            description: 'permissionsScreen.readDatabaseItemsDescription',
          },
          {
            permissionType: PermissionType.createItem,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.createDatabaseItems',
            description: 'permissionsScreen.createDatabaseItemsDescription',
          },
          {
            permissionType: PermissionType.updateItemValue,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.updateDatabaseItems',
            description: 'permissionsScreen.updateDatabaseItemsDescription',
          },
          {
            permissionType: PermissionType.deleteItem,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.deleteDatabaseItems',
            description: 'permissionsScreen.deleteDatabaseItemsDescription',
          },
        ],
      },
      {
        title: 'permissionsScreen.conversations',
        items: [
          {
            permissionType: PermissionType.conversationAdmin,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.conversationAdmin',
            description: 'permissionsScreen.overwriteAllOtherPermissions',
          },
          {
            permissionType: PermissionType.readConversation,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.viewConversations',
            description: 'permissionsScreen.viewConversationsDescription',
          },
          {
            permissionType: PermissionType.updateConversation,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.updateConversations',
            description: 'permissionsScreen.updateConversationsDescription',
          },
          {
            permissionType: PermissionType.deleteConversation,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.deleteConversations',
            description: 'permissionsScreen.deleteConversationsDescription',
          },
        ],
      },
      {
        title: 'permissionsScreen.calls',
        items: [
          {
            permissionType: PermissionType.callRoomAdmin,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.callAdmin',
            description: 'permissionsScreen.overwriteAllOtherPermissions',
          },
          {
            permissionType: PermissionType.readCallRoom,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.viewCalls',
            description: 'permissionsScreen.viewCallsDescription',
          },
          {
            permissionType: PermissionType.updateCallRoom,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.updateCalls',
            description: 'permissionsScreen.updateCallsDescription',
          },
          {
            permissionType: PermissionType.deleteCallRoom,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.deleteCalls',
            description: 'permissionsScreen.deleteCallsDescription',
          },
        ],
      },
      {
        title: 'permissionsScreen.dashboards',
        items: [
          {
            permissionType: PermissionType.dashboardAdmin,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.dashboardAdmin',
            description: 'permissionsScreen.overwriteAllOtherPermissions',
          },
          {
            permissionType: PermissionType.readDashboard,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.viewDashboards',
            description: 'permissionsScreen.viewDashboardsDescription',
          },
          {
            permissionType: PermissionType.updateDashboard,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.updateDashboards',
            description: 'permissionsScreen.updateDashboardsDescription',
          },
          {
            permissionType: PermissionType.deleteDashboard,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.deleteDashboards',
            description: 'permissionsScreen.deleteDashboardsDescription',
          },
        ],
      },
      {
        title: 'permissionsScreen.dashboardItems',
        items: [
          {
            permissionType: PermissionType.dashboardItemAdmin,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.dashboardItemAdmin',
            description: 'permissionsScreen.overwriteAllOtherPermissions',
          },
          {
            permissionType: PermissionType.readDashboardItem,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.viewDashboardItem',
            description: 'permissionsScreen.viewDashboardItemDescription',

          },
          {
            permissionType: PermissionType.createDashboardItem,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.createDashboardItem',
            description: 'permissionsScreen.createDashboardItemDescription',

          },
          {
            permissionType: PermissionType.updateDashboardItem,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.updateDashboardItem',
            description: 'permissionsScreen.updateDashboardItemDescription',

          },
          {
            permissionType: PermissionType.deleteDashboardItem,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.deleteDashboardItem',
            description: 'permissionsScreen.deleteDashboardItemDescription',

          },
        ],
      },
      {
        title: 'permissionsScreen.folders',
        items: [
          {
            permissionType: PermissionType.folderAdmin,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.folderAdmin',
            description: 'permissionsScreen.resourceGroupAdminDescription',
          },
          {
            permissionType: PermissionType.readFolder,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.viewFolders',
            description: 'permissionsScreen.viewFoldersDescription',
          },
          {
            permissionType: PermissionType.createFolder,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.createFolders',
            description: 'permissionsScreen.createFoldersDescription',
          },
          {
            permissionType: PermissionType.updateFolder,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.updateFolders',
            description: 'permissionsScreen.updateFoldersDescription',
          },
          {
            permissionType: PermissionType.deleteFolder,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.deleteFolders',
            description: 'permissionsScreen.deleteFoldersDescription',
          },
        ],
      },
      {
        title: 'permissionsScreen.cloudItems',
        items: [
          {
            permissionType: PermissionType.readCloudItem,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.readCloudItems',
            description: 'permissionsScreen.readCloudItemsDescription',
          },
          {
            permissionType: PermissionType.createCloudItem,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.createCloudItems',
            description: 'permissionsScreen.createCloudItemsDescription',
          },
          {
            permissionType: PermissionType.updateCloudItem,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.updateCloudItems',
            description: 'permissionsScreen.updateCloudItemsDescription',
          },
          {
            permissionType: PermissionType.deleteCloudItem,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.deleteCloudItems',
            description: 'permissionsScreen.deleteCloudItemsDescription',
          },
        ],
      },
      {
        title: 'permissionsScreen.automations',
        items: [
          {
            permissionType: PermissionType.automationAdmin,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.automationAdmin',
            description: 'permissionsScreen.resourceGroupAdminDescription',
          },
          {
            permissionType: PermissionType.readAutomation,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.viewAutomations',
            description: 'permissionsScreen.viewAutomationsDescription',
          },
          {
            permissionType: PermissionType.updateAutomation,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.updateAutomations',
            description: 'permissionsScreen.updateAutomationsDescription',
          },
          {
            permissionType: PermissionType.deleteAutomation,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.deleteAutomations',
            description: 'permissionsScreen.deleteAutomationsDescription',
          },
        ],
      },
      {
        title: 'permissionsScreen.resourceGroups',
        items: [
          {
            permissionType: PermissionType.resourceGroupAdmin,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.resourceGroupAdmin',
            description: 'permissionsScreen.resourceGroupAdminDescription',
          },
          {
            permissionType: PermissionType.readResourceGroup,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.readResourceGroups',
            description: 'permissionsScreen.readResourceGroupsDescription',
          },
          {
            permissionType: PermissionType.createResourceGroup,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.createResourceGroups',
            description: 'permissionsScreen.createResourceGroupsDescription',
          },
          {
            permissionType: PermissionType.updateResourceGroup,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.updateResourceGroups',
            description: 'permissionsScreen.updateResourceGroupsDescription',
          },
          {
            permissionType: PermissionType.deleteResourceGroup,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.deleteResourceGroups',
            description: 'permissionsScreen.deleteResourceGroupsDescription',
          },
        ],
      },
    ],
  }],
  [ResourceType.Database, {
    accessPermissionType: PermissionType.readDatabase,
    deletePermissionType: PermissionType.deleteDatabase,
    updatePermissionType: PermissionType.updateDatabase,
    createPermissionType: PermissionType.createDatabase,
    categories: [
      {
        title: 'permissionsScreen.database',
        items: [
          {
            permissionType: PermissionType.databaseAdmin,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.databaseAdmin',
            description: 'permissionsScreen.databaseAdminDescription',
          },
          {
            permissionType: PermissionType.readDatabase,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.viewDatabase',
            description: 'permissionsScreen.viewDatabaseDescription',
          },
          {
            permissionType: PermissionType.updateDatabase,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateDatabase',
            description: 'permissionsScreen.updateDatabaseDescription',
          },
          {
            permissionType: PermissionType.deleteDatabase,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.deleteDatabase',
            description: 'permissionsScreen.deleteDatabaseDescription',
          },
          {
            permissionType: PermissionType.exportDatabase,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.exportDatabase',
            description: 'permissionsScreen.exportDatabaseDescription',
          },
        ],
      },
      {
        title: 'permissionsScreen.properties',
        items: [
          {
            permissionType: PermissionType.databasePropertyAdmin,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.databasePropertyAdmin',
            description: 'permissionsScreen.resourceGroupAdminDescription',
          },
          {
            permissionType: PermissionType.readDatabaseProperty,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.readProperties',
            description: 'permissionsScreen.readPropertiesDescription',
          },
          {
            permissionType: PermissionType.createDatabaseProperty,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.createProperties',
            description: 'permissionsScreen.createPropertiesDescription',
          },
          {
            permissionType: PermissionType.updateDatabaseProperty,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateProperties',
            description: 'permissionsScreen.updatePropertiesDescription',
          },
          {
            permissionType: PermissionType.updateItemValue,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateItemValue',
            description: 'permissionsScreen.updateItemValueDescription',
          },
          {
            permissionType: PermissionType.deleteDatabaseProperty,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.deleteProperties',
            description: 'permissionsScreen.deletePropertiesDescription',
          },
          {
            permissionType: PermissionType.moveDatabaseProperties,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.moveProperties',
            description: 'permissionsScreen.movePropertiesDescription',
          },
        ],
      },
      {
        title: 'permissionsScreen.items',
        items: [
          {
            permissionType: PermissionType.itemAdmin,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.itemAdmin',
            description: 'permissionsScreen.resourceGroupAdminDescription',
          },
          {
            permissionType: PermissionType.readItem,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.readItems',
            description: 'permissionsScreen.readItemsDescription',
          },
          {
            permissionType: PermissionType.createItem,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.createItems',
            description: 'permissionsScreen.createItemsDescription',
          },
          {
            permissionType: PermissionType.updateItemValue,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateItems',
            description: 'permissionsScreen.updateItemsDescription',
          },
          {
            permissionType: PermissionType.updateItemState,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.publishItems',
            description: 'permissionsScreen.publishItemsDescription',
          },
          {
            permissionType: PermissionType.deleteItem,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.deleteItems',
            description: 'permissionsScreen.deleteItemsDescription',
          },
        ],
      },
      {
        title: 'permissionsScreen.filters',
        items: [
          {
            permissionType: PermissionType.readItemBaseFilter,
            inputType: PermissionInputType.Filter,
            title: 'permissionsScreen.baseReadFilter',
            description: 'permissionsScreen.baseReadFilterDescription',
          },
          {
            permissionType: PermissionType.createItemToBaseFilter,
            inputType: PermissionInputType.Filter,
            title: 'permissionsScreen.baseCreateFilter',
            description: 'permissionsScreen.baseCreateFilterDescription',
          },
          {
            permissionType: PermissionType.updateItemFromBaseFilter,
            inputType: PermissionInputType.Filter,
            title: 'permissionsScreen.baseUpdateFilterFrom',
            description: 'permissionsScreen.baseUpdateFilterFromDescription',
          },
          {
            permissionType: PermissionType.updateItemToBaseFilter,
            inputType: PermissionInputType.Filter,
            title: 'permissionsScreen.baseUpdateFilterTo',
            description: 'permissionsScreen.baseUpdateFilterToDescription',
          },
        ],
      },
      {
        title: 'permissionsScreen.views',
        items: [
          {
            permissionType: PermissionType.databaseViewAdmin,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.viewAdmin',
            description: 'permissionsScreen.viewAdminDescription',
          },
          {
            permissionType: PermissionType.readDatabaseView,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.readViews',
            description: 'permissionsScreen.readViewsDescription',
          },
          {
            permissionType: PermissionType.createDatabaseView,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.createViews',
            description: 'permissionsScreen.createViewsDescription',
          },
          {
            permissionType: PermissionType.updateDatabaseView,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateViews',
            description: 'permissionsScreen.updateViewsDescription',
          },
          {
            permissionType: PermissionType.deleteDatabaseView,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.deleteViews',
            description: 'permissionsScreen.deleteViewsDescription',
          },
        ],
      },
      {
        title: 'permissionsScreen.slices',
        items: [
          {
            permissionType: PermissionType.databaseSliceAdmin,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.sliceAdmin',
            description: 'permissionsScreen.sliceAdminDescription',
          },
          {
            permissionType: PermissionType.readDatabaseSlice,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.readSlices',
            description: 'permissionsScreen.readSlicesDescription',
          },
          {
            permissionType: PermissionType.createDatabaseSlice,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.createSlices',
            description: 'permissionsScreen.createSlicesDescription',
          },
          {
            permissionType: PermissionType.updateDatabaseSlice,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateSlices',
            description: 'permissionsScreen.updateSlicesDescription',
          },
          {
            permissionType: PermissionType.deleteDatabaseSlice,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.deleteSlices',
            description: 'permissionsScreen.deleteSlicesDescription',
          },
          {
            permissionType: PermissionType.updateDatabaseSlicePosition,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateSlicePosition',
            description: 'permissionsScreen.updateSlicePositionDescription',
          },
        ],
      },
    ],
  }],
  [ResourceType.DatabaseProperty, {
    accessPermissionType: PermissionType.readDatabaseProperty,
    deletePermissionType: PermissionType.deleteDatabaseProperty,
    updatePermissionType: PermissionType.updateDatabaseProperty,
    createPermissionType: PermissionType.createDatabaseProperty,
    categories: [
      {
        title: 'permissionsScreen.property',
        items: [
          {
            permissionType: PermissionType.databasePropertyAdmin,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.propertyAdministrator',
            description: 'permissionsScreen.overwriteAlmostAllOptions',
          },
          {
            permissionType: PermissionType.readDatabaseProperty,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.readDatabaseProperty',
            description: 'permissionsScreen.readDatabasePropertyDescription',
          },
          {
            permissionType: PermissionType.updateDatabaseProperty,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateDatabaseProperty',
            description: 'permissionsScreen.updateDatabasePropertyDescription',
          },
          {
            permissionType: PermissionType.manageDatabasePropertyMasking,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.manageDatabasePropertyMasking',
            description: 'permissionsScreen.manageDatabasePropertyMaskingDescription',
          },
          {
            permissionType: PermissionType.updateItemValue,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateThisItemValue',
            description: 'permissionsScreen.updateThisItemValueDescription',
          },
          {
            permissionType: PermissionType.deleteDatabaseProperty,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.deleteDatabaseProperty',
            description: 'permissionsScreen.deleteDatabasePropertyDescription',
          },
          {
            permissionType: PermissionType.updatePermission,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateThisPermission',
            description: 'permissionsScreen.updateThisPermissionDescription',
          },
        ],
      },
    ],
  }],
  [ResourceType.DatabaseView, {
    accessPermissionType: PermissionType.readDatabaseView,
    deletePermissionType: PermissionType.deleteDatabaseView,
    updatePermissionType: PermissionType.updateDatabaseView,
    createPermissionType: PermissionType.createDatabaseView,
    categories: [
      {
        title: 'permissionsScreen.view',
        items: [
          {
            permissionType: PermissionType.databaseViewAdmin,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.viewAdmin',
            description: 'permissionsScreen.overwriteAlmostAllOptions',
          },
          {
            permissionType: PermissionType.readDatabaseView,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.accessToThisView',
            description: 'permissionsScreen.readDatabaseViewDescription',
          },
          {
            permissionType: PermissionType.updateDatabaseView,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateThisView',
            description: 'permissionsScreen.updateDatabaseViewDescription',
          },
          {
            permissionType: PermissionType.deleteDatabaseView,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.deleteThisView',
            description: 'permissionsScreen.deleteDatabaseViewDescription',
          },
          {
            permissionType: PermissionType.updatePermission,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateThisPermission',
            description: 'permissionsScreen.updateThisPermissionDescription',
          },
        ],
      },
    ],
  }],
  [ResourceType.Conversation, {
    accessPermissionType: PermissionType.readConversation,
    deletePermissionType: PermissionType.deleteConversation,
    updatePermissionType: PermissionType.updateConversation,
    createPermissionType: PermissionType.createConversation,
    categories: [
      {
        title: 'permissionsScreen.conversation',
        items: [
          {
            permissionType: PermissionType.conversationAdmin,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.conversationAdmin',
            description: 'permissionsScreen.resourceGroupAdminDescription',
            
          },
          {
            permissionType: PermissionType.readConversation,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.readConversation',
            description: 'permissionsScreen.readConversationDescription',
            
          },
          {
            permissionType: PermissionType.updateConversation,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateConversation',
            description: 'permissionsScreen.updateConversationDescription',
            
          },
          {
            permissionType: PermissionType.deleteConversation,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.deleteConversation',
            description: 'permissionsScreen.deleteConversationDescription',

          },
          {
            permissionType: PermissionType.updatePermission,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateThisPermission',
            description: 'permissionsScreen.updateThisPermissionDescription',
          },
        ],
      },
    ],
  }],
  [ResourceType.CallRoom, {
    accessPermissionType: PermissionType.readCallRoom,
    deletePermissionType: PermissionType.deleteCallRoom,
    updatePermissionType: PermissionType.updateCallRoom,
    createPermissionType: PermissionType.createCallRoom,
    categories: [
      {
        title: 'permissionsScreen.call',
        items: [
          {
            permissionType: PermissionType.callRoomAdmin,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.callAdmin',
            description: 'permissionsScreen.resourceGroupAdminDescription',
            
          },
          {
            permissionType: PermissionType.readCallRoom,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.readCallRoom',
            description: 'permissionsScreen.readCallRoomDescription',
            
          },
          {
            permissionType: PermissionType.updateCallRoom,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateCallRoom',
            description: 'permissionsScreen.updateCallRoomDescription',
            
          },
          {
            permissionType: PermissionType.deleteCallRoom,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.deleteCallRoom',
            description: 'permissionsScreen.deleteCallRoomDescription',
            
          },
          {
            permissionType: PermissionType.updatePermission,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateThisPermission',
            description: 'permissionsScreen.updateThisPermissionDescription',
          },
        ],
      },
    ],
  }],
  [ResourceType.Dashboard, {
    accessPermissionType: PermissionType.readDashboard,
    deletePermissionType: PermissionType.deleteDashboard,
    updatePermissionType: PermissionType.updateDashboard,
    createPermissionType: PermissionType.createDashboard,
    categories: [
      {
        title: 'permissionsScreen.dashboard',
        items: [
          {
            permissionType: PermissionType.dashboardAdmin,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.dashboardAdmin',
            description: 'permissionsScreen.resourceGroupAdminDescription',
            
          },
          {
            permissionType: PermissionType.readDashboard,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.readDashboard',
            description: 'permissionsScreen.readDashboardDescription',
            
          },
          {
            permissionType: PermissionType.updateDashboard,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateDashboard',
            description: 'permissionsScreen.updateDashboardDescription',
            
          },
          {
            permissionType: PermissionType.deleteDashboard,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.deleteDashboard',
            description: 'permissionsScreen.deleteDashboardDescription',
            
          },
          {
            permissionType: PermissionType.updatePermission,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateThisPermission',
            description: 'permissionsScreen.updateThisPermissionDescription',
          },
        ],
      },
      {
        title: 'permissionsScreen.dashboardItems',
        items: [
          {
            permissionType: PermissionType.dashboardItemAdmin,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.dashboardItemAdmin',
            description: 'permissionsScreen.overwriteAllOtherPermissions',
          },
          {
            permissionType: PermissionType.readDashboardItem,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.viewDashboardItem',
            description: 'permissionsScreen.viewDashboardItemDescription',
          },
          {
            permissionType: PermissionType.createDashboardItem,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.createDashboardItem',
            description: 'permissionsScreen.createDashboardItemDescription',
          },
          {
            permissionType: PermissionType.updateDashboardItem,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateDashboardItem',
            description: 'permissionsScreen.updateDashboardItemDescription',
          },
          {
            permissionType: PermissionType.deleteDashboardItem,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.deleteDashboardItem',
            description: 'permissionsScreen.deleteDashboardItemDescription',
          },
          {
            permissionType: PermissionType.updatePermission,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateThisPermission',
            description: 'permissionsScreen.updateThisPermissionDescription',
          },
        ],
      },
    ],
  }],
  [ResourceType.Automation, {
    accessPermissionType: PermissionType.readAutomation,
    deletePermissionType: PermissionType.deleteAutomation,
    updatePermissionType: PermissionType.updateAutomation,
    createPermissionType: PermissionType.createAutomation,
    categories: [
      {
        title: 'permissionsScreen.automation',
        items: [
          {
            permissionType: PermissionType.automationAdmin,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.automationAdmin',
            description: 'permissionsScreen.resourceGroupAdminDescription',
          },
          {
            permissionType: PermissionType.readAutomation,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.readAutomation',
            description: 'permissionsScreen.readAutomationDescription',
          
          },
          {
            permissionType: PermissionType.updateAutomation,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateAutomation',
            description: 'permissionsScreen.updateAutomationDescription',
            
          },
          {
            permissionType: PermissionType.deleteAutomation,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.deleteAutomation',
            description: 'permissionsScreen.deleteAutomationDescription',
            
          },
          {
            permissionType: PermissionType.updatePermission,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateThisPermission',
            description: 'permissionsScreen.updateThisPermissionDescription',
          },
        ],
      },
    ],
  }],
  [ResourceType.App, {
    accessPermissionType: PermissionType.readApp,
    deletePermissionType: PermissionType.deleteApp,
    updatePermissionType: PermissionType.updateApp,
    createPermissionType: PermissionType.createApp,
    categories: [
      {
        title: 'permissionsScreen.app',
        items: [
          {
            permissionType: PermissionType.appAdmin,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.appAdmin',
            description: 'permissionsScreen.resourceGroupAdminDescription',
            
          },
          {
            permissionType: PermissionType.readApp,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.readApp',
            description: 'permissionsScreen.readAppDescription',
            
          },
          {
            permissionType: PermissionType.updateApp,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateApp',
            description: 'permissionsScreen.updateAppDescription',
            
          },
          {
            permissionType: PermissionType.deleteApp,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.deleteApp',
            description: 'permissionsScreen.deleteAppDescription',
            
          },
          {
            permissionType: PermissionType.updatePermission,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateThisPermission',
            description: 'permissionsScreen.updateThisPermissionDescription',
          },
        ],
      },
    ],
  }],
  [ResourceType.Folder, {
    accessPermissionType: PermissionType.readFolder,
    deletePermissionType: PermissionType.deleteFolder,
    updatePermissionType: PermissionType.updateFolder,
    createPermissionType: PermissionType.createFolder,
    categories: [
      {
        title: 'permissionsScreen.folder',
        items: [
          {
            permissionType: PermissionType.folderAdmin,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.folderAdmin',
            description: 'permissionsScreen.resourceGroupAdminDescription',
          },
          {
            permissionType: PermissionType.readFolder,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.readFolder',
            description: 'permissionsScreen.readFolderDescription',
          },
          {
            permissionType: PermissionType.updateFolder,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateFolder',
            description: 'permissionsScreen.updateFolderDescription',
          },
          {
            permissionType: PermissionType.deleteFolder,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.deleteFolder',
            description: 'permissionsScreen.deleteFolderDescription',
          },
          {
            permissionType: PermissionType.updatePermission,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateThisPermission',
            description: 'permissionsScreen.updateThisPermissionDescription',
          },
        ],
      },
      {
        title: 'permissionsScreen.cloudItems',
        items: [
          {
            permissionType: PermissionType.readCloudItem,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.readCloudItem',
            description: 'permissionsScreen.readCloudItemDescription',
          },
          {
            permissionType: PermissionType.createCloudItem,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.createCloudItem',
            description: 'permissionsScreen.createCloudItemDescription',
          },
          {
            permissionType: PermissionType.updateCloudItem,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateCloudItem',
            description: 'permissionsScreen.updateCloudItemDescription',
          },
          {
            permissionType: PermissionType.deleteCloudItem,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.deleteCloudItem',
            description: 'permissionsScreen.deleteCloudItemDescription',
          },
        ],
      },
    ],
  }],
  [ResourceType.CloudItem, {
    accessPermissionType: PermissionType.readCloudItem,
    deletePermissionType: PermissionType.deleteCloudItem,
    updatePermissionType: PermissionType.updateCloudItem,
    createPermissionType: PermissionType.createCloudItem,
    categories: [
      {
        title: 'permissionsScreen.cloudItem',
        items: [
          {
            permissionType: PermissionType.readCloudItem,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.readCloudItem',
            description: 'permissionsScreen.readCloudItemDescription',
          },
          {
            permissionType: PermissionType.updateCloudItem,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateCloudItem',
            description: 'permissionsScreen.updateCloudItemDescription',
          },
          {
            permissionType: PermissionType.deleteCloudItem,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.deleteCloudItem',
            description: 'permissionsScreen.deleteCloudItemDescription',
          },
          {
            permissionType: PermissionType.updatePermission,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateThisPermission',
            description: 'permissionsScreen.updateThisPermissionDescription',
          },
        ],
      },
    ],
  }],
  [ResourceType.DirectConversation, {
    accessPermissionType: PermissionType.readDirectConversation,
    deletePermissionType: null,
    updatePermissionType: PermissionType.updateDirectConversation,
    createPermissionType: null,
    categories: [
      {
        title: 'permissionsScreen.chat',
        items: [
          {
            permissionType: PermissionType.directConversationAdmin,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.directConversationAdmin',
            description: 'permissionsScreen.chatAdminDescription',

          },
          {
            permissionType: PermissionType.readDirectConversation,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.readDirectConversation',
            description: 'permissionsScreen.defaultAccessPermission',

            private: true,
            isVisible: true,
          },
          {
            permissionType: PermissionType.updateDirectConversation,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.updateDirectConversation',
            description: 'permissionsScreen.defaultAccessPermission',

            private: true,
          },
        ],
      },
    ],
  }],
  [ResourceType.DashboardItem, {
    accessPermissionType: PermissionType.readDashboardItem,
    deletePermissionType: PermissionType.deleteDashboardItem,
    updatePermissionType: PermissionType.updateDashboardItem,
    createPermissionType: PermissionType.createDashboardItem,
    categories: [
      {
        title: 'permissionsScreen.dashboardItem',
        items: [
          {
            permissionType: PermissionType.dashboardItemAdmin,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.dashboardItemAdmin',
            description: 'permissionsScreen.resourceGroupAdminDescription',
          },
          {
            permissionType: PermissionType.readDashboardItem,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.viewDashboardItem',
            description: 'permissionsScreen.viewDashboardItemDescription',
          },
          {
            permissionType: PermissionType.createDashboardItem,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.createDashboardItem',
            description: 'permissionsScreen.createDashboardItemDescription',
          },
          {
            permissionType: PermissionType.updateDashboardItem,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateDashboardItem',
            description: 'permissionsScreen.updateDashboardItemDescription',
          },
          {
            permissionType: PermissionType.deleteDashboardItem,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.deleteDashboardItem',
            description: 'permissionsScreen.deleteDashboardItemDescription',
          },
          {
            permissionType: PermissionType.updatePermission,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateThisPermission',
            description: 'permissionsScreen.updateThisPermissionDescription',
          },
        ],
      },
    ],
  }],
  [ResourceType.AutomationVersion, {
    accessPermissionType: PermissionType.readAutomationVersion,
    deletePermissionType: PermissionType.deleteAutomationVersion,
    updatePermissionType: PermissionType.updateAutomationVersion,
    createPermissionType: PermissionType.createAutomationVersion,
    categories: [
      {
        title: 'permissionsScreen.automationVersion',
        items: [
          {
            permissionType: PermissionType.automationVersionAdmin,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.automationVersionAdmin',
            description: 'permissionsScreen.resourceGroupAdminDescription',
          },
          {
            permissionType: PermissionType.readAutomationVersion,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.readAutomationVersion',
            description: 'permissionsScreen.readAutomationVersionDescription',
          },
          {
            permissionType: PermissionType.createAutomationVersion,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.createAutomationVersion',
            description: 'permissionsScreen.createAutomationVersionDescription',
          },
          {
            permissionType: PermissionType.updateAutomationVersion,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateAutomationVersion',
            description: 'permissionsScreen.updateAutomationVersionDescription',
          },
          {
            permissionType: PermissionType.deleteAutomationVersion,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.deleteAutomationVersion',
            description: 'permissionsScreen.deleteAutomationVersionDescription',
          },
          {
            permissionType: PermissionType.updatePermission,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateThisPermission',
            description: 'permissionsScreen.updateThisPermissionDescription',
          },
        ],
      },
    ],
  }],
  [ResourceType.DatabaseSlice, {
    accessPermissionType: PermissionType.readDatabaseSlice,
    deletePermissionType: PermissionType.deleteDatabaseSlice,
    updatePermissionType: PermissionType.updateDatabaseSlice,
    createPermissionType: PermissionType.createDatabaseSlice,
    categories: [
      {
        title: 'permissionsScreen.databaseSlice',
        items: [
          {
            permissionType: PermissionType.databaseSliceAdmin,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.databaseSliceAdmin',
            description: 'permissionsScreen.resourceGroupAdminDescription',
          },
          {
            permissionType: PermissionType.readDatabaseSlice,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.readDatabaseSlice',
            description: 'permissionsScreen.readDatabaseSliceDescription',
          },
          {
            permissionType: PermissionType.createDatabaseSlice,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.createDatabaseSlice',
            description: 'permissionsScreen.createDatabaseSliceDescription',
          },
          {
            permissionType: PermissionType.updateDatabaseSlice,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateDatabaseSlice',
            description: 'permissionsScreen.updateDatabaseSliceDescription',
          },
          {
            permissionType: PermissionType.deleteDatabaseSlice,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.deleteDatabaseSlice',
            description: 'permissionsScreen.deleteDatabaseSliceDescription',
          },
          {
            permissionType: PermissionType.updatePermission,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateThisPermission',
            description: 'permissionsScreen.updateThisPermissionDescription',
          },
        ],
      },
    ],
  }],
  [ResourceType.ResourceGroup, {
    accessPermissionType: PermissionType.readResourceGroup,
    deletePermissionType: PermissionType.deleteResourceGroup,
    updatePermissionType: PermissionType.updateResourceGroup,
    createPermissionType: PermissionType.createResourceGroup,
    categories: [
      {
        title: 'permissionsScreen.resourceGroup',
        items: [
          {
            permissionType: PermissionType.resourceGroupAdmin,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.resourceGroupAdmin',
            description: 'permissionsScreen.resourceGroupAdminDescription',
          },
          {
            permissionType: PermissionType.readResourceGroup,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.readResourceGroup',
            description: 'permissionsScreen.readResourceGroupDescription',
          },
          {
            permissionType: PermissionType.createResourceGroup,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.createResourceGroup',
            description: 'permissionsScreen.createResourceGroupDescription',
          },
          {
            permissionType: PermissionType.updateResourceGroup,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateResourceGroup',
            description: 'permissionsScreen.updateResourceGroupDescription',
          },
          {
            permissionType: PermissionType.deleteResourceGroup,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.deleteResourceGroup',
            description: 'permissionsScreen.deleteResourceGroupDescription',
          },
          {
            permissionType: PermissionType.updatePermission,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateThisPermission',
            description: 'permissionsScreen.updateThisPermissionDescription',
          },
        ],
      },
    ],
  }],
  [ResourceType.ResourceSpace, {
    accessPermissionType: PermissionType.readWorkspace,
    deletePermissionType: null,
    updatePermissionType: PermissionType.updateWorkspace,
    createPermissionType: null,
    categories: [
      {
        title: 'permissionsScreen.resourceSpace',
        items: [
          {
            permissionType: PermissionType.readWorkspace,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.viewResourceSpace',
            description: 'permissionsScreen.readWorkspaceDescription',
          },
          {
            permissionType: PermissionType.updateWorkspace,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateResourceSpace',
            description: 'permissionsScreen.updateWorkspaceDescription',
          },
          {
            permissionType: PermissionType.updatePermission,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateThisPermission',
            description: 'permissionsScreen.updateThisPermissionDescription',
          },
        ],
      },
    ],
  }],
  [ResourceType.AppAutomation, {
    accessPermissionType: PermissionType.readAppAutomation,
    deletePermissionType: PermissionType.deleteAppAutomation,
    updatePermissionType: PermissionType.updateAppAutomation,
    createPermissionType: PermissionType.createAppAutomation,
    categories: [
      {
        title: 'permissionsScreen.appAutomation',
        items: [
          {
            permissionType: PermissionType.appAutomationAdmin,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.appAutomationAdmin',
            description: 'permissionsScreen.resourceGroupAdminDescription',
          },
          {
            permissionType: PermissionType.readAppAutomation,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.readAppAutomation',
            description: 'permissionsScreen.readAppAutomationDescription',
          },
          {
            permissionType: PermissionType.createAppAutomation,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.createAppAutomation',
            description: 'permissionsScreen.createAppAutomationDescription',
          },
          {
            permissionType: PermissionType.updateAppAutomation,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateAppAutomation',
            description: 'permissionsScreen.updateAppAutomationDescription',
          },
          {
            permissionType: PermissionType.deleteAppAutomation,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.deleteAppAutomation',
            description: 'permissionsScreen.deleteAppAutomationDescription',
          },
          {
            permissionType: PermissionType.updatePermission,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateThisPermission',
            description: 'permissionsScreen.updateThisPermissionDescription',
          },
        ],
      },
    ],
  }],
  [ResourceType.WebhookListenerDefinition, {
    accessPermissionType: PermissionType.readWebhookListenerDefinition,
    deletePermissionType: PermissionType.deleteWebhookListenerDefinition,
    updatePermissionType: PermissionType.updateWebhookListenerDefinition,
    createPermissionType: PermissionType.createWebhookListenerDefinition,
    categories: [
      {
        title: 'permissionsScreen.webhookListenerDefinition',
        items: [
          {
            permissionType: PermissionType.webhookListenerDefinitionAdmin,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.webhookListenerDefinitionAdmin',
            description: 'permissionsScreen.resourceGroupAdminDescription',
          },
          {
            permissionType: PermissionType.readWebhookListenerDefinition,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.readWebhookListenerDefinition',
            description: 'permissionsScreen.readWebhookListenerDefinitionDescription',
          },
          {
            permissionType: PermissionType.createWebhookListenerDefinition,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.createWebhookListenerDefinition',
            description: 'permissionsScreen.createWebhookListenerDefinitionDescription',
          },
          {
            permissionType: PermissionType.updateWebhookListenerDefinition,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateWebhookListenerDefinition',
            description: 'permissionsScreen.updateWebhookListenerDefinitionDescription',
          },
          {
            permissionType: PermissionType.deleteWebhookListenerDefinition,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.deleteWebhookListenerDefinition',
            description: 'permissionsScreen.deleteWebhookListenerDefinitionDescription',
          },
          {
            permissionType: PermissionType.updatePermission,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateThisPermission',
            description: 'permissionsScreen.updateThisPermissionDescription',
          },
        ],
      },
    ],
  }],
  [ResourceType.WebhookListener, {
    accessPermissionType: PermissionType.readWebhookListener,
    deletePermissionType: PermissionType.deleteWebhookListener,
    updatePermissionType: PermissionType.updateWebhookListener,
    createPermissionType: PermissionType.createWebhookListener,
    categories: [
      {
        title: 'permissionsScreen.webhookListener',
        items: [
          {
            permissionType: PermissionType.webhookListenerAdmin,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.webhookListenerAdmin',
            description: 'permissionsScreen.resourceGroupAdminDescription',
          },
          {
            permissionType: PermissionType.readWebhookListener,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.readWebhookListener',
            description: 'permissionsScreen.readWebhookListenerDescription',
          },
          {
            permissionType: PermissionType.createWebhookListener,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.createWebhookListener',
            description: 'permissionsScreen.createWebhookListenerDescription',
          },
          {
            permissionType: PermissionType.updateWebhookListener,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateWebhookListener',
            description: 'permissionsScreen.updateWebhookListenerDescription',
          },
          {
            permissionType: PermissionType.deleteWebhookListener,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.deleteWebhookListener',
            description: 'permissionsScreen.deleteWebhookListenerDescription',
          },
          {
            permissionType: PermissionType.updatePermission,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateThisPermission',
            description: 'permissionsScreen.updateThisPermissionDescription',
          },
        ],
      },
    ],
  }],
  [ResourceType.Connection, {
    accessPermissionType: PermissionType.readConnection,
    deletePermissionType: PermissionType.deleteConnection,
    updatePermissionType: PermissionType.updateConnection,
    createPermissionType: PermissionType.createConnection,
    categories: [
      {
        title: 'permissionsScreen.connection',
        items: [
          {
            permissionType: PermissionType.connectionAdmin,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.connectionAdmin',
            description: 'permissionsScreen.resourceGroupAdminDescription',
          },
          {
            permissionType: PermissionType.readConnection,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.readConnection',
            description: 'permissionsScreen.readConnectionDescription',
          },
          {
            permissionType: PermissionType.createConnection,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.createConnection',
            description: 'permissionsScreen.createConnectionDescription',
          },
          {
            permissionType: PermissionType.updateConnection,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateConnection',
            description: 'permissionsScreen.updateConnectionDescription',
          },
          {
            permissionType: PermissionType.deleteConnection,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.deleteConnection',
            description: 'permissionsScreen.deleteConnectionDescription',
          },
          {
            permissionType: PermissionType.updatePermission,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateThisPermission',
            description: 'permissionsScreen.updateThisPermissionDescription',
          },
        ],
      },
    ],
  }],
  [ResourceType.ConnectionDefinition, {
    accessPermissionType: PermissionType.readConnectionDefinition,
    deletePermissionType: PermissionType.deleteConnectionDefinition,
    updatePermissionType: PermissionType.updateConnectionDefinition,
    createPermissionType: PermissionType.createConnectionDefinition,
    categories: [
      {
        title: 'permissionsScreen.connectionDefinition',
        items: [
          {
            permissionType: PermissionType.connectionDefinitionAdmin,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.connectionDefinitionAdmin',
            description: 'permissionsScreen.resourceGroupAdminDescription',
          },
          {
            permissionType: PermissionType.readConnectionDefinition,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.readConnectionDefinition',
            description: 'permissionsScreen.readConnectionDefinitionDescription',
          },
          {
            permissionType: PermissionType.createConnectionDefinition,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.createConnectionDefinition',
            description: 'permissionsScreen.createConnectionDefinitionDescription',
          },
          {
            permissionType: PermissionType.updateConnectionDefinition,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateConnectionDefinition',
            description: 'permissionsScreen.updateConnectionDefinitionDescription',
          },
          {
            permissionType: PermissionType.deleteConnectionDefinition,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.deleteConnectionDefinition',
            description: 'permissionsScreen.deleteConnectionDefinitionDescription',
          },
          {
            permissionType: PermissionType.updatePermission,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateThisPermission',
            description: 'permissionsScreen.updateThisPermissionDescription',
          },
        ],
      },
    ],
  }],
  [ResourceType.DynamicFieldDefinition, {
    accessPermissionType: PermissionType.readDynamicFieldDefinition,
    deletePermissionType: PermissionType.deleteDynamicFieldDefinition,
    updatePermissionType: PermissionType.updateDynamicFieldDefinition,
    createPermissionType: PermissionType.createDynamicFieldDefinition,
    categories: [
      {
        title: 'permissionsScreen.dynamicFieldDefinition',
        items: [
          {
            permissionType: PermissionType.dynamicFieldDefinitionAdmin,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.dynamicFieldDefinitionAdmin',
            description: 'permissionsScreen.resourceGroupAdminDescription',
          },
          {
            permissionType: PermissionType.readDynamicFieldDefinition,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.readDynamicFieldDefinition',
            description: 'permissionsScreen.readDynamicFieldDefinitionDescription',
          },
          {
            permissionType: PermissionType.createDynamicFieldDefinition,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.createDynamicFieldDefinition',
            description: 'permissionsScreen.createDynamicFieldDefinitionDescription',
          },
          {
            permissionType: PermissionType.updateDynamicFieldDefinition,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateDynamicFieldDefinition',
            description: 'permissionsScreen.updateDynamicFieldDefinitionDescription',
          },
          {
            permissionType: PermissionType.deleteDynamicFieldDefinition,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.deleteDynamicFieldDefinition',
            description: 'permissionsScreen.deleteDynamicFieldDefinitionDescription',
          },
          {
            permissionType: PermissionType.updatePermission,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateThisPermission',
            description: 'permissionsScreen.updateThisPermissionDescription',
          },
        ],
      },
    ],
  }],
  [ResourceType.Cron, {
    accessPermissionType: PermissionType.readCron,
    deletePermissionType: PermissionType.deleteCron,
    updatePermissionType: PermissionType.updateCron,
    createPermissionType: PermissionType.createCron,
    categories: [
      {
        title: 'permissionsScreen.cron',
        items: [
          {
            permissionType: PermissionType.readCron,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.readCron',
            description: 'permissionsScreen.readCronDescription',
          },
          {
            permissionType: PermissionType.createCron,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.createCron',
            description: 'permissionsScreen.createCronDescription',
          },
          {
            permissionType: PermissionType.updateCron,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateCron',
            description: 'permissionsScreen.updateCronDescription',
          },
          {
            permissionType: PermissionType.deleteCron,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.deleteCron',
            description: 'permissionsScreen.deleteCronDescription',
          },
          {
            permissionType: PermissionType.updatePermission,
            inputType: PermissionInputType.BooleanWithInheritance,
            title: 'permissionsScreen.updateThisPermission',
            description: 'permissionsScreen.updateThisPermissionDescription',
          },
        ],
      },
    ],
  }],
  [ResourceType.Document, {
    accessPermissionType: PermissionType.readDocument,
    deletePermissionType: PermissionType.deleteDocument,
    updatePermissionType: PermissionType.updateDocument,
    createPermissionType: PermissionType.createDocument,
    categories: [
      {
        title: 'permissionsScreen.document',
        items: [
          {
            permissionType: PermissionType.documentAdmin,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.documentAdmin',
            description: 'permissionsScreen.overwriteAllOtherPermissions',
          },
          {
            permissionType: PermissionType.readDocument,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.viewDocument',
            description: 'permissionsScreen.viewDocumentDescription',
          },
          {
            permissionType: PermissionType.updateDocument,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.updateDocument',
            description: 'permissionsScreen.updateDocumentDescription',
          },
          {
            permissionType: PermissionType.deleteDocument,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.deleteDocument',
            description: 'permissionsScreen.deleteDocumentDescription',
          },
          {
            permissionType: PermissionType.exportDocument,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.exportDocument',
            description: 'permissionsScreen.exportDocumentDescription',
          },
        ],
      },
      {
        title: 'permissionsScreen.documentContent',
        items: [
          {
            permissionType: PermissionType.commentDocument,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.commentDocument',
            description: 'permissionsScreen.commentDocumentDescription',
          },
          {
            permissionType: PermissionType.mentionInDocument,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.mentionInDocument',
            description: 'permissionsScreen.mentionInDocumentDescription',
          },
          {
            permissionType: PermissionType.updatePermission,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.updatePermission',
            description: 'permissionsScreen.updatePermissionDescription',
          },
        ],
      },
    ],
  }],
  [ResourceType.Whiteboard, {
    accessPermissionType: PermissionType.readWhiteboard,
    deletePermissionType: PermissionType.deleteWhiteboard,
    updatePermissionType: PermissionType.updateWhiteboard,
    createPermissionType: PermissionType.createWhiteboard,
    categories: [
      {
        title: 'permissionsScreen.whiteboard',
        items: [
          {
            permissionType: PermissionType.whiteboardAdmin,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.whiteboardAdmin',
            description: 'permissionsScreen.overwriteAllOtherPermissions',
          },
          {
            permissionType: PermissionType.readWhiteboard,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.viewWhiteboard',
            description: 'permissionsScreen.viewWhiteboardDescription',
          },
          {
            permissionType: PermissionType.updateWhiteboard,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.updateWhiteboard',
            description: 'permissionsScreen.updateWhiteboardDescription',
          },
          {
            permissionType: PermissionType.deleteWhiteboard,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.deleteWhiteboard',
            description: 'permissionsScreen.deleteWhiteboardDescription',
          },
          {
            permissionType: PermissionType.exportWhiteboard,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.exportWhiteboard',
            description: 'permissionsScreen.exportWhiteboardDescription',
          },
          {
            permissionType: PermissionType.updatePermission,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.updatePermission',
            description: 'permissionsScreen.updatePermissionDescription',
          },
        ],
      },
    ],
  }],
  [ResourceType.Skill, {
    accessPermissionType: PermissionType.readSkill,
    deletePermissionType: PermissionType.deleteSkill,
    updatePermissionType: PermissionType.updateSkill,
    createPermissionType: PermissionType.createSkill,
    categories: [
      {
        title: 'permissionsScreen.skill',
        items: [
          {
            permissionType: PermissionType.skillAdmin,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.skillAdmin',
            description: 'permissionsScreen.skillAdminDescription',
          },
          {
            permissionType: PermissionType.readSkill,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.viewSkill',
            description: 'permissionsScreen.viewSkillDescription',
          },
          {
            permissionType: PermissionType.updateSkill,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.updateSkill',
            description: 'permissionsScreen.updateSkillDescription',
          },
          {
            permissionType: PermissionType.publishSkill,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.publishSkill',
            description: 'permissionsScreen.publishSkillDescription',
          },
          {
            permissionType: PermissionType.deleteSkill,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.deleteSkill',
            description: 'permissionsScreen.deleteSkillDescription',
          },
          {
            permissionType: PermissionType.updatePermission,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.updateSkillPermission',
            description: 'permissionsScreen.updateSkillPermissionDescription',
          },
        ],
      },
    ],
  }],
  [ResourceType.Agent, {
    accessPermissionType: PermissionType.readAgent,
    deletePermissionType: PermissionType.deleteAgent,
    updatePermissionType: PermissionType.updateAgent,
    createPermissionType: PermissionType.createAgent,
    categories: [
      {
        title: 'permissionsScreen.agent',
        items: [
          {
            permissionType: PermissionType.agentAdmin,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.App]: PermissionInputType.Boolean,
              [PermissionEntityType.Agent]: PermissionInputType.Boolean,
            },
            title: 'permissionsScreen.agentAdmin',
            description: 'permissionsScreen.agentAdminDescription',
          },
          {
            permissionType: PermissionType.readAgent,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.App]: PermissionInputType.Boolean,
              [PermissionEntityType.Agent]: PermissionInputType.Boolean,
            },
            title: 'permissionsScreen.viewAgent',
            description: 'permissionsScreen.viewAgentDescription',
          },
          {
            permissionType: PermissionType.updateAgent,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.updateAgent',
            description: 'permissionsScreen.updateAgentDescription',
          },
          {
            permissionType: PermissionType.publishAgent,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.publishAgent',
            description: 'permissionsScreen.publishAgentDescription',
          },
          {
            permissionType: PermissionType.deleteAgent,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.deleteAgent',
            description: 'permissionsScreen.deleteAgentDescription',
          },
          {
            permissionType: PermissionType.mentionInAgent,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.App]: PermissionInputType.Boolean,
              [PermissionEntityType.Agent]: PermissionInputType.Boolean,
            },
            title: 'permissionsScreen.mentionInAgent',
            description: 'permissionsScreen.mentionInAgentDescription',
          },
          {
            permissionType: PermissionType.updatePermission,
            inputType: PermissionInputType.Boolean,
            inputTypePerEntity: {
              [PermissionEntityType.User]: PermissionInputType.BooleanWithInheritance,
              [PermissionEntityType.Group]: PermissionInputType.BooleanWithInheritance,
            },
            title: 'permissionsScreen.updateAgentPermission',
            description: 'permissionsScreen.updateAgentPermissionDescription',
          },
        ],
      },
    ],
  }],
])

const planCapabilitySchemaCategory: IPermissionResourceSchemaCategory = {
  title: 'permissionsScreen.defaultAccessPermission',
  items: PLAN_CAP_PERMISSION_TYPES.map(permissionType => ({
    permissionType,
    inputType: PermissionInputType.Boolean,
    title: 'permissionsScreen.defaultAccessPermission',
    description: 'permissionsScreen.defaultAccessPermission',
    private: true,
    isVisible: false,
  })),
}

PermissionResourceSchemaMap.get(ResourceType.Workspace)?.categories.push(planCapabilitySchemaCategory)
